export const NAME = 'ui';

export const MODALS = {
  INVOICE_TABLE_MODAL: 'InvoiceModal',
  USER_DETAILS_MODAL: 'UserDetailsModal',
};
